import ManualReviewBill from '../../../bills/components/ManualReviewBill';

export default function BillReviewAddScreen() {
    return <ManualReviewBill />;
}
